import { c as _c } from "react/compiler-runtime";
export default function MirrorIcon() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <circle cx="45" cy="45" r="45" fill="#007AFF" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipPath="url(#clip0_389_2394)"><path d="M26 39.5806C26 29.3188 34.3188 21 44.5806 21C54.8426 21 63.1613 29.3188 63.1613 39.5806V66.1766C63.1613 67.7359 61.8973 69 60.3376 69H28.8235C27.2641 69 26 67.7359 26 66.1766V39.5806Z" fill="url(#paint0_linear_389_2394)" /><path fillRule="evenodd" clipRule="evenodd" d="M60.9536 66.6937V39.6348C60.9536 30.5659 53.6234 23.214 44.5806 23.214C35.5381 23.214 28.2076 30.5659 28.2076 39.6348V66.6937C28.2076 66.7448 28.2488 66.786 28.2996 66.786H60.8618C60.9126 66.786 60.9536 66.7448 60.9536 66.6937ZM44.5806 21C34.3188 21 26 29.3431 26 39.6348V66.6937C26 67.9674 27.0296 69 28.2996 69H60.8618C62.1318 69 63.1613 67.9674 63.1613 66.6937V39.6348C63.1613 29.3431 54.8426 21 44.5806 21Z" fill="white" /></g>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <linearGradient id="paint0_linear_389_2394" x1="30.7831" y1="23.7675" x2="63.2965" y2="75.343" gradientUnits="userSpaceOnUse"><stop offset="0.265625" stopColor="white" /><stop offset="0.734375" stopColor="#007AFF" /></linearGradient>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-w-full tw-h-full tw-align-top" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">{t0}{t1}<defs>{t2}<clipPath id="clip0_389_2394"><rect width="37.3622" height="48" fill="white" transform="translate(26 21)" /></clipPath></defs></svg>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}